import React from "react";
// import '../../styles/GeneralStyles.scss';
import "./BtnRegistro.scss";

const BtnRegistro = () => {
  return <button className="btn-yellow">REGISTRO</button>;
};

export default BtnRegistro;
